import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import Aux from "../../../../hoc/Auxilary";
import SelectionFields from '../../../../hoc/UI/SelectionFields/SelectionFields'
import { Button } from 'rsuite'

class StakeholderForm extends Component {
    constructor(props) {
        super(props);

        if (this.props.values["organization_id"]) {
            this.props.values.stakeholder_type = "Organization";
        } else if (this.props.values["agency_id"]) {
            this.props.values.stakeholder_type = "Agency";
        }
    }

  render() {
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
            this.props.setFieldTouched("stakeholder_catetory_id", true);
            this.props.setFieldTouched("stakeholder_role_id", true);

          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;
          if ("stakeholder_type" in values) {
              if (values["stakeholder_type"] === "Organization") {
                  if ("agency_id" in values) {
                      delete values["agency_id"];
                  }
                  values["organization_id"] = parseInt(values["organization_id"]);
              }
              if (values["stakeholder_type"] === "Agency") {
                  if ("organization_id" in values) {
                      delete values["organization_id"];
                  }
                  values["agency_id"] = parseInt(values["agency_id"]);
              }
              delete values["stakeholder_type"];
          }
          func(values);
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form>
          <fieldset disabled={this.props.disabled}>
              <small className={"d-block col-12"}><span style={{color:"red"}}>*</span> required</small>

              <label
                  className={"col-12"}
                  style={this.props.errors.stakeholder_type && this.props.touched.stakeholder_type && {color: "red"}}>
                  <div className={"required"}>
                    Stakeholder Type
                  </div>
                  <Field
                      style={this.props.errors.stakeholder_type && this.props.touched.stakeholder_type && {borderColor: "red"}}
                      className="form-control col-12"
                      id={"stakeholder_type"}
                      name={"stakeholder_type"}
                      component={"select"}
                      value={this.props.values.stakeholder_type || "default"}
                  >
                      <option value={"default"}>--select one--</option>
                      <option value={"Organization"}>Private Organization</option>
                      <option value={"Agency"}>Public Agency</option>
                  </Field>
                  {this.props.errors.stakeholder_type && this.props.touched.stakeholder_type && (
                      <small className={"text-danger"}>{this.props.errors.stakeholder_type}</small>
                  )}
              </label>



              {this.props.values.stakeholder_type === "Organization" ? (
                  <SelectionFields
                      showError={this.props.errors.organization_id && this.props.touched.organization_id}
                      size={"col-12"}
                      id={"organization_id"}
                      url={"organization"}
                      showElem={"name"}
                      label={"Organization"}
                      value={this.props.values["organization_id"] || "default"}
                      isRequired={true}
                      errorMessage={this.props.errors.organization_id && this.props.touched.organization_id && (
                          <small className="text-danger">{this.props.errors.organization_id}</small>
                      )}
                  />
              ) : ""}

              {this.props.values.stakeholder_type === "Agency" ? (
                  <SelectionFields
                      showError={this.props.errors.agency_id && this.props.touched.agency_id}
                      size={"col-12"}
                      id={"agency_id"}
                      url={"agency"}
                      showElem={"agency_name"}
                      label={"Agency"}
                      value={this.props.values["agency_id"] || "default"}
                      isRequired={true}
                      errorMessage={this.props.errors.agency_id && this.props.touched.agency_id && (
                          <small className="text-danger">{this.props.errors.agency_id}</small>
                      )}
                  />
              ) : ""}

              <SelectionFields
                  showError={this.props.errors.stakeholder_catetory_id && this.props.touched.stakeholder_catetory_id}
                  size={"col-12"}
                  id={"stakeholder_catetory_id"}
                  url={"stakeholder_category_lkp"}
                  showElem={"name"}
                  label={"Stakeholder Category"}
                  value={this.props.values["stakeholder_catetory_id"] || "default"}
                  isRequired={true}
                  errorMessage=              {this.props.errors.stakeholder_catetory_id && this.props.touched.stakeholder_catetory_id && (
                      <small className="text-danger">{this.props.errors.stakeholder_catetory_id}</small>
                  )}
              />

              <SelectionFields
                  showError={this.props.errors.stakeholder_role_id && this.props.touched.stakeholder_role_id}
                  size={"col-12"}
                  id={"stakeholder_role_id"}
                  url={"stakeholder_role_lkp"}
                  showElem={"name"}
                  label={"Stakeholder Role"}
                  value={this.props.values["stakeholder_role_id"] || "default"}
                  isRequired={true}
                  errorMessage=              {this.props.errors.stakeholder_role_id && this.props.touched.stakeholder_role_id && (
                      <small className="text-danger">{this.props.errors.stakeholder_role_id}</small>
                  )}
                  finalizeData={data => {
                      return data.sort((a, b) => (a.display_order < b.display_order) ? -1 :
                          (a.display_order > b.display_order ? 1 : 0));
                  }}
              />

        <label className="col-12">
          To Role Or Org
          <Field
                className="form-control"
            name={"to_role_or_org"}
            value={this.props.values.to_role_or_org || ""}
          />
        </label>

        <label className="col-12">
          Notes
          <Field
              rows={4}
              component={"textarea"}
                className="form-control" name={"notes"} value={this.props.values.notes || ""} />
        </label>

          </fieldset>
          {this.props.disabled ? ( <Button className={"ml-2"} type="button" onClick={this.props.toggleSmallModalHandler}>
              Cancel
          </Button>) : (
              <div>
              {!this.props.currentStakeholder ? (
                  <Button
                      color={"blue"}
                    type="button"
                    onClick={() => {
                      validAndHandle(this.props.add, this.props.values);
                    }}
                  >
                    Submit
                  </Button>
                ) : (
                  <Aux>
                    <Button
                        color={"blue"}
                      type="button"
                      onClick={() => {
                        validAndHandle(this.props.update, this.props.values);
                      }}
                    >
                      Update
                    </Button>
                  </Aux>
                )}
                  <Button className={"ml-2"} color="red" type="button" onClick={this.props.handleReset}>
                      Reset
                  </Button>
                  <Button className={"ml-2"} type="button" onClick={this.props.toggleSmallModalHandler}>
                      Cancel
                  </Button>
              </div>
          )}
      </Form>
    );
  }
}

var StakeholderSchema = Yup.object().shape({
    stakeholder_catetory_id: Yup.string().required(),
    stakeholder_role_id: Yup.number().required(),
});

export default withFormik({
  validationSchema: StakeholderSchema,

  mapPropsToValues({ currentStakeholder }) {
    return {
      ...currentStakeholder
    };
  }
})(StakeholderForm);
